import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { emailError, inviteSuccess } from '@/utils/alerts.service';
import router from '@/router/dashboard.js';

/*
  This is the form to send invitations to agencies
*/
export const inviteAgencies = {
  namespaced: true,
  actions: {
    sendInvites({ dispatch }, invites) {
      let success = 0;
      for (let invite of invites) {
        const data = {
          name: invite.agencyName,
          email: invite.email,
          inviteName: invite.name,
        };

        vendorDashboardAPI
          .sendInvite(data)
          .then(res => {
            if (res.status < 400) {
              success++;
              dispatch('showUserMessage', { ...inviteSuccess }, { root: true });
              if (success === invites.length) {
                router.push('/partners');
              }
            } else {
              const errorMessages = emailError;
              errorMessages.message = res.data.email[0];
              dispatch('showUserMessage', { ...errorMessages }, { root: true });
            }
          })
          .catch(() => {
            dispatch('showUserMessage', { ...emailError }, { root: true });
          });
      }
    },
  },
};
